import loadable from '@loadable/component';
import { ReactNode } from 'react';

import { Dropdown } from 'components/Dropdown/Dropdown';
import { searchGetVolopsRoutePath } from 'modules/search/routing/helpers/searchGetVolopsRoutePath';
import { hydrateOnDemand } from 'utils/hydrateOnDemand/hydrateOnDemand';

type Props = {
  locale: UserLocale;
  renderTrigger: (data: {
    triggerText: string;
    triggerHref: string;
  }) => ReactNode;
  trackClickedContext: string;
};

const triggerTextByLocale: Record<UserLocale, { text: string; href: string }> =
  {
    en: {
      text: 'Take Action',
      href: searchGetVolopsRoutePath({ lang: 'en' }),
    },
    es: {
      text: 'Actúa',
      href: searchGetVolopsRoutePath({ lang: 'es' }),
    },
    pt: {
      text: 'Conectar',
      href: searchGetVolopsRoutePath({ lang: 'pt' }),
    },
  };

const TakeActionDropdownMenuLoadable = hydrateOnDemand(
  loadable(() => import('./TakeActionDropdownMenu'), {
    resolveComponent: (module) => module.TakeActionDropdownMenu,
  }),
);

export function TakeActionDropdown({
  locale,
  renderTrigger,
  trackClickedContext,
}: Props) {
  const { text, href } = triggerTextByLocale[locale];

  return (
    <Dropdown
      trigger={renderTrigger({ triggerText: text, triggerHref: href })}
      desktopTriggersOnHover
    >
      <TakeActionDropdownMenuLoadable
        locale={locale}
        trackClickedContext={trackClickedContext}
      />
    </Dropdown>
  );
}
